import { h } from 'preact';
const  account = (props) => (
	<svg viewBox="0 0 72 72" class={props.class}>
		<path d="M35.6,2C45.8,2,54,10,54,20.2v0.2c0,10.2-8,18.2-18.1,18.4c-10.1,0-18.4-8-18.4-18.2C17.3,10.3,25.5,2,35.6,2 M67.7,69.3c0,0.5-0.2,0.7-0.7,0.7H5c-0.5,0-0.7-0.2-0.7-0.7c0-13.2,14.6-24.1,31.6-24.1C53.1,45,67.4,56.1,67.7,69.3" />
	</svg>
);
export default account;


// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/account/index.js